import { DEFAULT_FONT_FAMILY_ID, DEFAULT_FONT_ID } from '@/lib/text/constants/text-defaults'
import type { Paragraph } from '@/api/types/stowed-element'

/**
 * Swaps every run whose font family is in `familyIds` to the default font (Helvetica). Returns the
 * rewritten paragraphs and whether any run changed; the paragraphs are rebuilt either way.
 */
export function replaceFontFamilies(
  paragraphs: Paragraph[] | undefined,
  familyIds: ReadonlySet<number>
): { paragraphs: Paragraph[]; hasChanges: boolean } {
  let hasChanges = false

  const updatedParagraphs = (paragraphs ?? []).map((p) => ({
    ...p,
    textLines: p.textLines?.map((line) => ({
      ...line,
      textRuns: line.textRuns?.map((run) => {
        if (run.fontFamilyId && familyIds.has(run.fontFamilyId)) {
          hasChanges = true

          return { ...run, fontFamilyId: DEFAULT_FONT_FAMILY_ID, fontId: DEFAULT_FONT_ID }
        }

        return run
      }),
    })),
  }))

  return { paragraphs: updatedParagraphs, hasChanges }
}
